export const stripQueryParams = (url) => {
  if (!url) return ''
  return url.split('?')[0].split('#')[0].split(';')[0]
}
